import {
  useEffect,
  useRef,
} from 'react';

interface UseIsMounted {
  isMounted: boolean;
  ifIsMounted: (fn: () => void) => void;
}

/**
 * A hook that we can use to determine if a component is mounted while running async tasks
 */
export default (initialMounted = false): UseIsMounted => {
  const isMountedRef = useRef(initialMounted);

  // after first render pass, useEffect will run setting isMountedRef.current to true
  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      // when the component unmounts, we update our ref value
      isMountedRef.current = false;
    };
  }, []);

  return {
    // export the ref
    isMounted: isMountedRef.current,
    // convenience function that will run fn only if mounted
    ifIsMounted: (fn: () => void) => { if (isMountedRef.current) fn(); },
  };
};
